import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'
import { FormMdxEditor } from '@/components/forms'

/**
 * FAQ Tab - Frequently Asked Questions
 *
 * Includes:
 * - FAQ content editor with MDXEditor (rich text/markdown)
 * - Support for structured Q&A format (headings, bullet points, nested lists)
 */
export function FAQTab() {
  const { t } = useTranslation()
  const { control } = useFormContext()

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
          {t('resources.assistants.faq.title')}
        </h2>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          {t('resources.assistants.faq.description')}
        </p>
      </div>

      <div className="rounded-lg border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-900">
        <FormMdxEditor
          name="prompt_scenarios.faq"
          control={control}
          placeholder={t('resources.assistants.faq.placeholder')}
          minHeight="400px"
          maxHeight="none"
          showDiffView={true}
        />

        <div className="mt-4 rounded-lg bg-gray-50 p-4 text-sm text-gray-600 dark:bg-gray-800 dark:text-gray-400">
          <strong className="font-medium text-gray-700 dark:text-gray-300">
            {t('resources.assistants.faq.tip_title')}:
          </strong>{' '}
          {t('resources.assistants.faq.tip_use')}{' '}
          <code className="rounded bg-gray-200 px-1 py-0.5 font-mono text-xs dark:bg-gray-700">
            ## Heading
          </code>{' '}
          {t('resources.assistants.faq.tip_sections')},{' '}
          <code className="rounded bg-gray-200 px-1 py-0.5 font-mono text-xs dark:bg-gray-700">
            **bold**
          </code>{' '}
          {t('resources.assistants.faq.tip_questions')},{' '}
          {t('resources.assistants.faq.tip_and')}{' '}
          <code className="rounded bg-gray-200 px-1 py-0.5 font-mono text-xs dark:bg-gray-700">
            - list items
          </code>{' '}
          {t('resources.assistants.faq.tip_bullet_points')}.
        </div>
      </div>
    </div>
  )
}
